import makeStyles from '@mui/styles/makeStyles';

interface EditableMediaStyleProps {
  isInEditMode: boolean;
}

export const useStyles = makeStyles((theme) => ({
  root: ({ isInEditMode }: EditableMediaStyleProps) => ({
    position: 'relative',
    width: '100%',
    '&:hover': {
      '& > div > button': {
        visibility: 'visible',
      },
    },
    '& button:nth-child(3)': {
      display: 'none',
    },
    ...(isInEditMode
      ? {
          '& > div:nth-child(1)': {
            width: '100% !important',
            '& figure': {
              '& div:nth-child(1)': {
                right: '4px !important',
              },
              '& div:nth-child(2)': {
                width: '100% !important',
              },
            },
          },
        }
      : null),
  }),
  iconContainer: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
  },
  editIcon: {
    backgroundColor: theme.palette.common.white,
    visibility: 'hidden',
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  fontSizeSmall: {
    fontSize: '1.2rem',
  },
}));
